import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import * as React from 'react';

type Props = {
  src?: string;
  title: string;
  className?: string;
  disableLoop?: boolean;
};

const Video = ({ src, title, className, disableLoop }: Props) => (
  <VideoContainer className={className}>
    {src ? (
      <video preload="auto" playsInline autoPlay loop={!disableLoop} disablePictureInPicture muted>
        <source src={src} title={title} type="video/mp4" />
      </video>
    ) : (
      <div />
    )}
  </VideoContainer>
);

export default motion(Video);

const VideoContainer = styled.div`
  width: 100%;
  height: 100%;

  video,
  div {
    width: 100%;
  }

  // Placeholder div
  div {
    background-color: #f7f7f7;
    width: 100%;

    @supports (aspect-ratio: 16 / 9) {
      aspect-ratio: 16 / 9;
    }

    @supports not (aspect-ratio: 16 / 9) {
      height: 40vw;
      padding-bottom: 60%;
    }
  }
`;
